export default {
  icon: 'warning',
  name: 'Alertes Hypervision',
  title: 'Alertes Hypervision',
  alert: 'Alerte(s)',
  hypervision: 'hypervision',
  noItems:
    "Il n'y a pas d'alertes Hypervision en relation avec l'organisation et les filtres sélectionnés",
  predityVision: {
    icon: 'mdi-eye-check-outline',
    name: 'MyVision',
  },
  deviceManagement: {
    icon: 'mdi-access-point-network',
    name: 'Device Management',
  },
  untreated: {
    name: 'Alertes Hypervision',
  },
  fields: {
    id: 'id',
    property_code: 'Code installation',
    property_name: 'Nom installation',
    property: 'Installation',
    code_agence: 'Code Agence',
    etat_chauffe: 'En chauffe',
    heating_on: 'En chauffe',
    heating_off: 'Hors chauffe',
    entity_id: 'Code équipe',
    entity_name: 'Nom équipe',
    alerte_legio: 'Legionella',
    agence: 'Agence',
    alerte_chauffage: 'Chauffage',
    alerte_ecs_chauffage: 'ECS',
    alerte_consommation: 'Ecart courant (MWh PCI)',
    alerte_conso_pct: 'Ecart courant (%)',
    alerte_conso_total: 'Ecart cumulé (MWh PCI)',
    alerte_ecs: 'q',
    autres_alertes: 'Autres alertes',
    alerte_chauff_datetime: 'Date alerte Chauffage',
    alerte_ecs_chauff_datetime: 'Date alerte ECS',
    alerte_conso_datetime: 'Date alerte Ecart(MWh PCI)',
    alerte_conso_pct_datetime: 'Date alerte Ecart(%)',
    alerte_ecs_datetime: 'Date alerte q',
    autres_alertes_datetime: 'Date autres alertes',
    alerte_chauff_origin: 'Alerte Chauffage',
    alerte_ecs_chauff_origin: 'Alerte ECS',
    alerte_conso_origin: 'Alerte Ecart(MWh PCI)',
    alerte_conso_pct_origin: 'Alerte Ecart(%)',
    alerte_ecs_origin: 'Alerte q',
    autres_alertes_origin: 'Autres alertes',
    alerte_predictive: 'Alertes prédictives',
    number: 'N°',
    priority: 'Priorité',
    sensors: 'Qualité des données',
    energy_cases: 'CAS Ste',
    action_plans: "Plans d'actions en cours",
    market_type: 'Type de marché',
    top_p1: 'Top P1',
    synthesis: 'Synthèse',
    priority_sort: 'Tri par valeur de priorité',
    alerte_sort: "Tri par date de l'aterte",
    alerte_value_sort: "Tri par valeur de l'alerte",
    actions: 'Actions',
  },
  icons: {
    alert: 'mdi-bell-ring-outline',
    remove: 'mdi-playlist-remove',
  },
  titles: {
    untreated: 'Non traitées',
    all: 'Toutes',
    predictive: 'Prédictives',
  },
};
